import React from 'react';
import PropTypes from 'prop-types';

const Pagination = ({
  items,
  itemsPerPage,
  setItemsPerPage,
  currentPage,
  setCurrentPage
}) => {
  const totalPages = Math.ceil(items.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getPageNumbers = (total, current) => {
    const pageNumbers = [];
    for (
      let i = Math.max(1, current - 1);
      i <= Math.min(total, current + 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  return (
    <div className="pagination">
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-btn"
      >
        Prev
      </button>

      {getPageNumbers(totalPages, currentPage).map((number) => (
        <button
          key={number}
          onClick={() => paginate(number)}
          className={
            currentPage === number
              ? 'pagination-btn active'
              : 'pagination-btn'
          }
        >
          {number}
        </button>
      ))}

      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="pagination-btn"
      >
        Next
      </button>

      <select
        value={itemsPerPage}
        onChange={handleItemsPerPageChange}
        className="items-per-page"
      >
        {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>

      <span className="pagination-info">
        Showing {indexOfFirstItem + 1} to{' '}
        {Math.min(indexOfLastItem, items.length)} of {items.length}
      </span>
    </div>
  );
};

/* =========================
   SONAR-COMPLIANT PROPTYPES
   ========================= */
Pagination.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  setItemsPerPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired
};

export default Pagination;
